// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6621e6c51468e20e74c6","655":"98ef32c4d168d3c1fa93"}[chunkId] + ".js";
};